import { useEffect } from "react";
import { useBackNavigationContext } from "@/contexts/BackNavigationContext";

/**
 * Detail pages call this hook to register a back button in the global header.
 * When the component unmounts, the registration is cleared.
 *
 * @param fallbackPath - Where to navigate if there's no browser history
 *                       (e.g. user opened page via bookmark)
 */
export function useRegisterBackNavigation(fallbackPath: string) {
  const { register, clear } = useBackNavigationContext();

  useEffect(() => {
    register(fallbackPath);
    return () => clear();
  }, [fallbackPath, register, clear]);
}
